module.exports = __webpack_public_path__ + "static/media/do-purple-sky.7d428881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/kits/do-purple-sky.jpg
// module id = 588
// module chunks = 0